import { z } from 'zod';

export interface AssetModelApi {
  id: string;
  name: string;
  brandId: string;
  brand?: {
    id: string;
    name: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export const assetModelSchema = z.object({
  name: z.string().min(1, 'Debes ingresar un nombre de modelo'),
  brandId: z.string().min(1, 'Debes seleccionar una marca'),
});

export type AssetModelSchema = z.infer<typeof assetModelSchema>;

export const defaultAssetModelValues: AssetModelSchema = {
  name: '',
  brandId: '',
}; 